import React, {useEffect, useState} from 'react';
import {Grid, useMediaQuery} from "@mui/material";
import DownloadCSVButton from "../../report/export/DownloadCSVButton";
import DownloadSpaceUsageCSVButton from '../DownloadSpaceUsageCSVButton';
import {getBuyerSpaceUsageReportUrl} from "../../../requests/reports/space-usage/buyer-space-usage-requests";

const BuyerSpaceUsageExportCSVs = (props) => {
    const { item, query, className } = props;
    const isMd = useMediaQuery(theme => theme.breakpoints.up('md'));

    const [basicReportUrl, setBasicReportUrl] = useState("");

    useEffect(() => {
        setBasicReportUrl(getBuyerSpaceUsageReportUrl(query));
    }, [query]);

    return (
        <Grid item={item} container gap={4} justifyContent={isMd ? 'flex-end' : 'space-between'} xs={12} md>
            <Grid item>
                <DownloadCSVButton
                    reportUrl={basicReportUrl}
                    title={'Download Report'}
                    className={className}/>
            </Grid>
            <DownloadSpaceUsageCSVButton
                query={query}
                isBuyer={true}
            />
        </Grid>
    )
};

export default BuyerSpaceUsageExportCSVs;
